<template>
<div class="MyCourseList" v-if="init">
    <NoData v-if="!dataList.length"></NoData>
    <pull :pull="pull" :page="page" @getList="getList">
        <div class="courseList">
            <div class="box" v-for="(obj) in dataList" :key="obj.courseid" @click="handleCourseView(obj)">
                <div class="left"><img class="img" v-lazy="obj.coverurl" alt=""></div>
                <div class="right">
                    <div class="subject">{{obj.subject}}</div>
                    <div class="schedule">
                        <div class="progress">
                            <van-progress v-if="obj.coursetype==2" :percentage="percentage(obj)" />
                        </div>
                        <div class="progressName">
                            <div v-if="obj.finishcount!=0&&obj.coursetype==1">已完成</div>
                            <div v-if="obj.finishcount==0">立即学习</div>
                            <div v-if="obj.finishcount!=0&&obj.coursetype==2">
                                <span>学习进度</span>
                                <span class="total">{{obj.finishcount}}/{{obj.totalcount}}</span>
                            </div>
                            <div class="expire" v-if="obj.isexpireorder">{{obj.expiredatename}}</div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </pull>
</div>
</template>

<script>
import {getUserJoinCourseList} from 'api/systemApi'
import Pull from 'views/mobile/components/pull/pull'
import {mapActions, mapGetters} from 'vuex'
import NoData from 'views/mobile/components/noData/noData'
export default {
    name: 'MyCourseList',
    data() {
        return {
            init: false,
            dataList: [
                // {
                //     courseid: '',
                //     coursetype: 1, // 课程类型：1 单课  2系列课
                //     finishcount: 0, // 已完成课时
                //     iscomment: 1, // 是否评论
                //     subject: '',
                //     totalcount: 0 // 总课时
                // }
            ],
            param: {},
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
        }
    },
    mounted() {
        this.getList()
        this.setNoDataTip('当前还没有学习课程，快去学习吧！')
        document.title = '我的课程'
        if (!this.refresh) {
            this.getList()
        }
    },
    activated() {
        if (this.refresh) {
            this.getList()
            this.setRefresh(false)
        }
    },
    methods: {
        handleCourseView(obj) {
            this.$router.push({name: 'MCourseView', query: {cid: obj.courseid}})
            this.setRefresh(true)
        },
        getList() {
            this.setLoading(true)
            getUserJoinCourseList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.init = true
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.dataList = data.data.content
                    } else {
                        this.dataList = this.dataList.concat(data.data.content)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh', 'setNoDataTip'])
    },
    filters: {},
    watch: {},
    computed: {
        percentage () {
            return function(obj) {
                obj.totalcount = obj.totalcount | 1
                return  parseInt((obj.finishcount / obj.totalcount) * 100)
            }
        },
        ...mapGetters(['refresh'])
    },
    components: {
        Pull, NoData
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.MyCourseList {
    .courseList{
        background: $c-white;
        padding: 0.16rem 0.32rem;
        .box{
            display: flex;
            justify-content: flex-start;
            font-size:0.28rem;
            font-weight: 600;
            padding: 0.28rem 0;
            background: $c-white;
            .left{
                min-width:2.6rem;
                max-width: 2.6rem;
                width: 2.6rem;
                height: 1.46rem;
                margin-right:0.2rem;
                .img{
                    width: 100%;
                    height: 100%;
                    border-radius: 0.04rem;
                }
            }
            .right{
                width: 4.84rem;
                .subject{
                    height: 0.8rem;
                    line-height: 0.4rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .schedule{
                    color: $c-grey;
                    font-size: 0.24rem;
                    .progress{
                        margin: 0.12rem 0;
                        height: 0.08rem;
                    }
                    .progressName{
                        margin-top: 0.12rem;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .total{
                            margin-left: 0.12rem;
                        }
                        .expire{
                           color: #F56C6C;
                        }
                    }
                }
            }
        }
        .box+.box{
            border-top: 0.01rem solid $line;
        }
    }
    .van-progress__pivot{
        display: none;
    }
    .van-progress__portion{
        background: $c-blue;
    }
    .noData{
        height: 100vh;
        background: $c-white;
    }
}
</style>